<template>
  <div class="tech-profile-approval-container">
    <div class="flex-row">
      <img
        src="@shared/assets/img/general/svg/info-white.svg"
        class="img-size-24"
        alt="info"
      />
      <div class="sac__font-16 med f-white ml-4">
        Technician has uploaded new profile photo
      </div>
    </div>
    <div class="flex-row">
      <button
        type="button"
        class="decline-profile-updates-btn"
        @click="decline"
      >
        <img
          v-if="decliningPhoto"
          src="@shared/assets/img/general/loading-white.svg"
          alt="loading"
        >
        <span v-else>Decline</span>
      </button>
      <button
        :disabled="savingPhoto"
        type="button"
        class="accept-profile-updates-btn"
        @click="accept"
      >
        <img
          v-if="savingPhoto"
          src="@shared/assets/img/general/loading-white.svg"
          alt="loading"
        >
        <span v-else>Accept</span>
      </button>
    </div>
  </div>
</template>
<script>
import technicianMixin from '@shared/mixins/technicianMixin';

export default {
  name: 'ProfileApproval',
  components: {},
  mixins: [technicianMixin],
  data() {
    return {
      savingPhoto: false,
      decliningPhoto: false,
    };
  },
  methods: {
    async decline() {
      this.decliningPhoto = true;
      await this.$store.dispatch('declineTech');
      this.decliningPhoto = false;
    },
    async accept() {
      this.savingPhoto = true;
      const tech = {
        ...this.selectedTech,
      };
      tech.profileUrl = tech.pendingProfileChanges.profileUrl;
      tech.pendingProfileChanges = { approvalPending: false };
      await this.$store.dispatch('updateTechnician', { updateTech: tech });
      this.savingPhoto = false;
    },
  },
};
</script>
<style lang="scss">
.tech-profile-approval-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: $BLUE_40;
    padding: 20px;
    margin: 20px 0;
    border-radius: 5px;
    .decline-profile-updates-btn {
      font-size: 14px;
      font-weight: 600;
      text-decoration: underline;
      color: $GRAY_50;
    }
    .accept-profile-updates-btn {
      border: 2px solid $WHITE;
      border-radius: 40px;
      font-size: 14px;
      width: 81px;
      height: 42px;
      color: $WHITE;
      margin-left: 20px;
    }
}
</style>
